exports = module.exports = require("../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".com-black-post-item{padding:8px 18px 0}.com-black-post-item .post-title{margin:0 auto 12px;font-weight:700;font-size:18px;word-break:break-all}.com-black-post-item .post-title em{color:#ff3d00;font-style:normal}.com-black-post-item .post-author{margin:0 auto 12px}.com-black-post-item .post-component-item+.post-component-item{margin-top:18px}.com-black-post-item .post-content-wrapper{position:relative}.com-black-post-item .post-content{padding-left:15px;color:#999;line-height:23px;font-size:14px;word-break:break-word;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}.com-black-post-item .post-content-line{position:absolute;top:0;bottom:0;left:0;width:6px;background-color:#f2f2f2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/component/black-post-item/scss/index.scss
// module id = 905
// module chunks = 0